module.exports = require("xregexp");